import React, { Component } from 'react';
import jwt_decode from "jwt-decode";
import { Table } from 'react-bootstrap';
import { withRouter} from 'react-router-dom';
import { Col } from 'react-bootstrap';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { CSVLink } from "react-csv";
import { FaFileCsv, FaFilePdf } from 'react-icons/fa';
import jsPDF from 'jspdf'
import 'jspdf-autotable'

import { registerLocale, setDefaultLocale } from  "react-datepicker";
import es from 'date-fns/locale/es';
import mixin from '../../../utils/mixin';
import consts from "../../../utils/constants";

import { getActivityByDevelopment, getUsersByDevelopment } from '../../../api/Api.js';

import NavbarMenu from '../NavbarMenu/NavbarMenu.js';

import './Reports.scss';

const {methods} = mixin;

registerLocale('es', es);

const CustomInput = React.forwardRef(({ value, onClick }, ref) => (
  <input type="text" className="form-control" value={value} onClick={onClick} ref={ref} />
));

class Reports extends Component {

  constructor(props){
    
    super(props);

    let dev = localStorage.getItem('dev');
    if(dev == null || dev == undefined || dev == ''){
      this.props.history.push("/admin");
      window.location.reload();
    }

    dev = JSON.parse(dev);
    
    let token = localStorage.getItem('jwt');

    if(token){
      const decoded = jwt_decode(token);
      let date = new Date(decoded.exp * 1000);
      let mydate = new Date();
      
      if (date <= mydate) {
        this.logout();
      }
    }else{
      this.logout();
    }

    methods.G_changeLanguage('es');

    this.state = {
      loading: false,
      loading_users: false,
      loading_info: false,
      lots: [],
      users: [],
      agents: [],
      items: [],
      development_id: dev.development_id,
      development: dev,
      startDate: new Date(),
      endDate: new Date(),
      selectedUser: '',
      selectedAgent: '',
      selectedType: '',
    }
  }

  

  logout = () => {
    localStorage.removeItem("jwt");
    localStorage.removeItem("user");
    localStorage.removeItem("developments");
    this.props.history.push("/admin/login");
    window.location.reload();
  }

  renderPrice = (object) => {
    if(object.price){
      if(object.discount && object.discount > 0){
        return(
          <p className="text-right">
            <b>Reserva con:</b> {methods.G_renderPrice(object.price, 'MXN')}<br/>
            <b>Descuento:</b> -{methods.G_renderPrice(object.discount,'MXN')}<br/>
            <b>Final:</b> {methods.G_renderPrice(object.price - object.discount, 'MXN')} <br/>
          </p>
        )
      }else{
        return(
          <p><b>Reserva con:</b> {methods.G_renderPrice(object.price, 'MXN')}</p>
        )
      }
    }
  }

  dispatchActivity = () => new Promise((resolve, reject) => {
    // const { developmentId } = this.state
    let startD = this.state.startDate;
    startD = startD.setHours(0, 0, 0, 0);
    
    let endD = this.state.endDate;
    endD = endD.setHours(23, 59, 59, 999);

    let user_id = null;
    if(this.isUserSeller()){
        let user = localStorage.getItem('user');
        user = JSON.parse(user);
        user_id = user.user_id;
    }
    
    getActivityByDevelopment({
      development_id: this.state.development_id,
      since: startD,
      until: endD,
      user: user_id,
    }).then((res) => {
      let items = [];
      if (res) {
        items = res;
      }

      this.setState({
        items: items,
      }, () => resolve('activity data ok'));
    });
  });

  dispatchUsers = () => {
    getUsersByDevelopment({
      development_id: this.state.development_id
    }).then((res) => {
      let users = [];
      let selectedUser = '';
      let agents = [];
      if (res) {
        if(this.isUserSeller()){
          let user = localStorage.getItem('user');
          user = JSON.parse(user);
          users = res.filter(x => x.user_id == user.user_id);
          selectedUser = 0;
          agents = this.getUserAgents(users[0]);
        }else{
          users = res;
        }
        
      }
      
      this.setState({
        users: users,
        agents: agents,
        selectedUser: selectedUser,
      });
    });
  }

  getUserAgents = (user) => {
    let agents = [];
    
    if(user && user.user_id){
      agents.push({
        agent_id: user.user_id,
        first_name: user.first_name,
        last_name: user.last_name,
        last_name_2: user.last_name_2,
        type: 'user',
        user_id: user.user_id,
        user_code: user.user_code
      });

      return agents.concat(user.agents);
    }

    return agents;
  }

  isUserSeller = () => {
    let user = localStorage.getItem('user');
    user = JSON.parse(user);
    return (consts.UserType.DEV_SELLER == user.type_id || consts.UserType.DEV_REAL_STATE == user.type_id);
  }

  applyFilters = (items) => {
    let tx = items ? items : [...this.state.items];
    
    if(this.state.startDate && this.state.endDate){
      tx = tx.filter( x => {
        let tx_date = new Date(x.created_time);
        let startD = this.state.startDate;
        startD = startD.setHours(0, 0, 0, 0);
        let endD = this.state.endDate;
        endD = endD.setHours(23, 59, 59, 999);
        
        return tx_date.getTime() >= startD && tx_date.getTime() <= endD;
      });
    }

    if(this.state.selectedUser || this.state.selectedUser === 0){
      if(this.state.users && this.state.users.length > 0){
        let user = this.state.users[this.state.selectedUser];
        tx = tx.filter(x => x.seller_user_id == user.user_id);
      }
    }

    if(this.state.selectedAgent || this.state.selectedAgent === 0){
      let agent = this.state.agents[this.state.selectedAgent];
      if(agent.type == 'user'){
        tx = tx.filter(x => x.agent_id == null);
      }else{
        tx = tx.filter(x => x.agent_id == agent.agent_id);
      }
    }

    if(this.state.selectedType){
      tx = tx.filter(x => x.type == this.state.selectedType);
    }

    return tx;
  }

  filtersBtnClick = (e) => {
    e.preventDefault();
    this.sendReportRequest();
  }

  sendReportRequest = () => {
    this.setState({
      loading_info: true,
    });
    let startD = this.state.startDate;
    startD = startD.setHours(0, 0, 0, 0);
    
    let endD = this.state.endDate ? this.state.endDate : this.state.startDate;
    endD = endD.setHours(23, 59, 59, 999);

    let user_id = null;
    if(this.state.selectedUser || this.state.selectedUser === 0){
      if(this.state.users && this.state.users.length > 0){
        let user = this.state.users[this.state.selectedUser];
        user_id = user.user_id;
      }
    }
    
    let agent_id = null;
    
    if(this.state.selectedAgent || this.state.selectedAgent === 0){
      let agent = this.state.agents[this.state.selectedAgent];
      if(agent.type !== 'user'){
        agent_id = agent.agent_id
      }
    }
  
    let type = null;
    if(this.state.selectedType){
      type = this.state.selectedType;
    }

    const data = {
      development_id: this.state.development_id,
      since: startD,
      until: endD,
      user: user_id,
      agent: agent_id,
      type: type,
    }

    getActivityByDevelopment(data).then((res) => {
      let items = [];
      if (res) {
        items = res;
      }

      this.setState({
        items: items,
        loading_info: false,
      });
    });
  }

  componentDidMount() {
    
    this.setState({
      loading: true
    }, () => {
      Promise.all([this.dispatchActivity()]).then(values => {
        
        this.setState({
            loading: false,
        });

      }, reason => {
          console.info(reason)
      });
    });

    this.dispatchUsers();
  }

  renderType = (type) => {
    switch(type){
      case 'VIEW': return 'Vista';
      case 'RESERVATION_BUTTON': return 'Intento de Reservación';
      default: return '-';
    }
  }

  renderName = (a) => {
    let label = '';
    if(a){
      label = a.first_name ? a.first_name: '' ;
      label += a.last_name ? ' ' + a.last_name : '';
      label += a.last_name_2 ? ' ' + a.last_name_2 : '';
    }
    return label;
  }

  renderAgent = (i) => {
    if(i.agent_id && i.agent && i.agent.first_name){
      return this.renderName(i.agent);
    }
    return this.renderName(i.user);
  }

  renderTable = () => {
    let txs = (this.state.items && this.state.items.length > 0) ? [...this.state.items] : [];

    const listTxs = txs ? txs.map((i) => {
      return( 
        <tr className="tx-item" key={i['_id']}>
          <td>{methods.G_simpleFormatDate({date: i.time_created + 'Z'})}</td>
          <td>{i.lot.name}</td>
          <td>{this.renderType(i.type)}</td>
          <td>{this.renderName(i.user)}</td>
          <td>{i.user.real_state_name ? i.user.real_state_name : '-'}</td>
          <td>{this.renderAgent(i)}</td>
        </tr>
      )
    }) : [];

    if(listTxs.length > 0){
      return (
        <Table striped responsive bordered hover size="sm" id="tx_table">
          <thead>
            <tr>
              <th>Fecha</th>
              <th>Lote</th>
              <th>Tipo</th>
              <th>Usuario</th>
              <th>Inmobiliaria</th>
              <th>Vendedor</th>
            </tr>
          </thead>
          <tbody>
            {listTxs}
          </tbody>
        </Table>
      );
    }else{
      return (
        <span>No hay actividad registrada en el período seleccionado.</span>
      );
    }

  }

  onDateChange = (dates) => {
    const [start, end] = dates;
    this.setState({
      startDate: start,
      endDate: end,
    });
  }

  onChangeUser = (e) => {
    const userIndex = e.target.value;
    const user = this.state.users[userIndex];
    this.setState({
      selectedUser: userIndex,
      agents: this.getUserAgents(user),
      selectedAgent: '',
    });
  }

  onChangeAgent = (e) => {
    this.setState({
      selectedAgent: e.target.value
    });
  }

  onChangeType = (e) => {
    this.setState({
      selectedType: e.target.value
    });
  }

  renderUserSelector = () => {
    let listUsers = [];
    if(this.state.users && this.state.users.length > 0){
      listUsers = this.state.users.map((a, i) => {
        let label = this.renderName(a);
        let k = a.user_id;
        if(a.real_state_name){
          label = a.real_state_name + ' / ' + label;
        }
        return (
          <option key={k} value={i}>{label}</option>
        );
      });
    }
    let options1 = <option value="">Todos</option>;
    if(this.isUserSeller()){
      options1 = null;
    }

    return (
      <select className="form-control" value={this.state.selectedUser} name='user_name' onChange={this.onChangeUser}>
        {options1}
        {listUsers}
      </select>
    );
  }

  renderAgentsSelector = () => {
    
    let listAgents = [];
    if(this.state.agents && this.state.agents.length > 0){
      listAgents = this.state.agents.map((a, i) => {
        let label = this.renderName(a);
        let k = a.agent_id; 
        let t = a.type
        return (
          <option key={t+'_'+k} value={i}>{label}</option>
        );
      });
    }

    return (
      <select className="form-control" value={this.state.selectedAgent} name='agent_name' onChange={this.onChangeAgent} >
        <option value="">Todos</option>
        {listAgents}
      </select>
    )
    
  }

  resetFilters = () => {
    this.setState({
      startDate: new Date(),
      endDate: new Date(),
      selectedUser: this.isUserSeller() ? 0 : '',      
      selectedAgent: '',
      selectedType: '',
    }, () => {
      this.sendReportRequest();
    });
    
  }

  getCSVData = () => {
    let csvData = [];

    csvData.push(['Fecha:', methods.G_simpleFormatDateOnly({date: this.state.startDate}) + ' - ' + methods.G_simpleFormatDateOnly({date: this.state.endDate})]);

    let userName = 'Todos';
    if(this.state.selectedUser){
      let user = this.state.users[this.state.selectedUser];
      userName = this.renderName(user);
    }
    csvData.push(['Usuario:', userName]);

    let agentName = 'Todos';
    if(this.state.selectedAgent){
      let agent = this.state.agents[this.state.selectedAgent];
      agentName = this.renderName(agent);
    }
    csvData.push(['Vendedor:', agentName]);

    let typeName = 'Todos';
    if(this.state.selectedType){
      switch(this.state.selectedType){
        case 'VIEW': typeName = 'Vista'; break;
        case 'RESERVATION_BUTTON': typeName = 'Intento de Reservación'; break;
        default: typeName = 'Todos'; break;
      }
    }
    csvData.push(['Tipo:', typeName]);

    csvData.push([]);

    csvData.push([
      'Fecha',
      'Lote',
      'Tipo',
      'Usuario',
      'Inmobiliaria',
      'Vendedor'
    ]);

    if(this.state.items && this.state.items.length > 0){
      const listTxs = this.state.items ? this.state.items.map((i) => {
        return [
          methods.G_simpleFormatDate({date: i.time_created + 'Z'}),
          i.lot.name,
          this.renderType(i.type),
          this.renderName(i.user),
          i.user.real_state_name ? i.user.real_state_name : '-',
          this.renderAgent(i)
        ];
      }) : [];

      if(listTxs){
        csvData = csvData.concat(listTxs)
      }
    }

    return csvData;
  }

  getFileName = () => {
    return 'Actividad_' + methods.G_simpleFormatDateOnly({date: new Date(), separator: '-'});
  }

  exportPDF = () => {
    const doc = new jsPDF({
      orientation: "landscape"
    });
    doc.setFontSize(14);
    doc.text("Actividad", 15, 10);
    doc.setFontSize(10);
    let range = methods.G_simpleFormatDateOnly({date: this.state.startDate}) + ' - ' + methods.G_simpleFormatDateOnly({date: this.state.endDate});
    doc.text("Fecha: " + range, 15, 20);
    let userName = 'Todos';
    if(this.state.selectedUser){
      let user = this.state.users[this.state.selectedUser];
      userName = this.renderName(user);
    }
    doc.text("Usuario: " + userName, 15, 26);
    let agentName = 'Todos';
    if(this.state.selectedAgent){
      let agent = this.state.agents[this.state.selectedAgent];
      agentName = this.renderName(agent);
    }
    doc.text("Vendedor: " + agentName, 15, 32);
    let typeName = 'Todos';
    if(this.state.selectedType){
      switch(this.state.selectedType){
        case 'VIEW': typeName = 'Vista'; break;
        case 'RESERVATION_BUTTON': typeName = 'Intento de Reservación'; break;
        default: typeName = 'Todos'; break;
      }
    }
    doc.text("Tipo: " + typeName, 15, 38);
    
    if(this.state.items.length > 0){
      doc.autoTable({ headStyles: { fillColor: [75, 92, 115] }, startY: 49, html: '#tx_table' })
    }else{
      doc.text("No hay actividad registrada en el período seleccionado.", 15, 49);
    }
    
    doc.save(this.getFileName() + ".pdf");
  }
  
  render() {
      const { lots, loading } = this.state;

      if (loading) {
        return (
          <div className="h-100">
            <NavbarMenu development={this.state.development} logout={this.logout} />
            <div className="container-fluid pt-4 h-100">
              Cargando...
            </div>
          </div>
        );
      }

      return (
        <div className="h-100">
          <NavbarMenu development={this.state.development} logout={this.logout} />
          <div className="container-fluid h-100 ext-container">
            <div className="row h-100">
              <div className="col-12 col-md-2 pt-4 pb-5 left-panel">
                <h4>Filtros</h4>
                <div className="row filter-row">
                  <Col xs="12">
                    <div className="form-group">
                      <label htmlFor="date_range_input">Fecha</label>
                      <DatePicker
                        id="date_range"
                        selected={this.state.startDate}
                        selectsRange
                        startDate={this.state.startDate}
                        endDate={this.state.endDate}
                        placeholderText='Selecccionar...'
                        dateFormat='dd/MM/yyyy'
                        onChange={this.onDateChange}
                        locale='es'
                        customInput={<CustomInput />}
                      />
                    </div>
                  </Col> 
                </div>
                <div className="row filter-row">
                  <Col xs="12">
                    <div className="form-group">
                      <label htmlFor="user_name">Inmobiliaria / Usuario</label>
                      {this.renderUserSelector()}
                    </div>
                  </Col> 
                </div>
                <div className="row filter-row">
                  <Col xs="12">
                    <div className="form-group">
                      <label htmlFor="agent_name">Vendedor</label>
                      {this.renderAgentsSelector()}
                    </div>
                  </Col> 
                </div>
                <div className="row filter-row">
                  <Col xs="12">
                    <div className="form-group">
                      <label htmlFor="tx_type">Tipo</label>
                      <select className="form-control"  value={this.state.selectedType} name='tx_type' onChange={this.onChangeType}>
                        <option value="">Todos</option>
                        <option value="VIEW">Vista</option>
                        <option value="RESERVATION_BUTTON">Intento de Reservación</option>
                      </select>
                    </div>
                  </Col> 
                </div>
                <div className="row filter-row">
                  <Col xs="12">
                    <div className="form-group text-right">
                      <button className="btn btn-cust-orange float-left" onClick={this.resetFilters.bind(this)}>Limpiar</button>
                      <button className="btn btn-cust-blue" onClick={this.filtersBtnClick.bind(this)} disabled={this.state.loading_info}>
                        {this.state.loading_info && (
                          <span className="spinner-border spinner-border-sm"></span>
                        )}
                        <span>Aplicar</span>
                      </button>
                    </div>
                  </Col> 
                </div>
              </div>

              <div className="col-12 col-md-10 pt-4 pb-5 right-panel">
                {
                  <div>
                    <h3>Actividad</h3>
                    <br/>
                    <div className="export-btns-container">
                      <CSVLink className="" data={this.getCSVData()} filename={this.getFileName() + '.csv'}><button className="btn btn-cust-green"><FaFileCsv /> CSV</button></CSVLink>
                      <button className="btn btn-cust-red ml-3" onClick={this.exportPDF}><FaFilePdf /> PDF</button>
                    </div>
                    
                    {this.renderTable()}
                  </div>
                }
              </div>  
            </div>
            
          </div>
        </div>
      );
  }

}

export default withRouter(Reports);